import type { MyPacksTabDef, MyPacksTabId } from './MyPacksHeader';

type Props = {
  tabs: MyPacksTabDef[];
  active: MyPacksTabId;
  onChange: (id: MyPacksTabId) => void;
};

/**
 * Sleek Vault tabs (partner mockup): plain labels with counts and a bar under
 * the active one.
 */
export function UnderlineTabs({ tabs, active, onChange }: Props) {
  return (
    <div
      role="tablist"
      aria-label="Vault sections"
      data-co-component="MyPacksTabs"
      className="flex w-full border-b border-solid border-[var(--co-MyPacksTabs-divider,rgba(255,255,255,0.03))]"
    >
      {tabs.map((tab) => {
        const isActive = tab.id === active;
        return (
          <button
            key={tab.id}
            type="button"
            role="tab"
            aria-selected={isActive}
            onClick={() => onChange(tab.id)}
            className={
              'relative flex flex-1 items-center justify-center gap-1.5 py-3 text-[14px] leading-[20px] font-semibold tracking-[-0.15px] transition-colors ' +
              (isActive
                ? 'text-[var(--co-MyPacksTabs-activeText,#FFFFFF)]'
                : 'text-[var(--co-MyPacksTabs-idleText,#6D707C)]')
            }
          >
            {tab.label}
            {isActive && (
              <span
                aria-hidden
                className="absolute inset-x-0 -bottom-px h-0.5 rounded-full bg-[var(--co-MyPacksTabs-indicator,#FFFFFF)]"
              />
            )}
          </button>
        );
      })}
    </div>
  );
}
